import logo from './logo.svg';
import './App.css';
import './responsive-utils.css';
import Approutes from './Approutes';
import { BrowserRouter } from 'react-router-dom';
import { LocationProvider } from './context/LocationContext';

function App() {
  return (
    <div className='App'>
      <BrowserRouter>
      <LocationProvider>
      <Approutes/>
      </LocationProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
